<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.mdAndDown ? true : false"
		:transition="$vuetify.breakpoint.mdAndDown ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.mdAndDown">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">{{ categoryName }}を追加</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-sheet class="pa-2" elevation="0">
				<table width="100%" class="mt-4 show-dialog-table show-dialog-table--form">
					<tbody>
						<ShowDetailRecord
							:columnName="'対象カテゴリ'"
							:value="categoryName"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
						/>
						<ShowDetailRecord :columnName="'対象品'">
							<template v-slot:value
								><v-select
									v-model="TODO"
									:items="itemsByCategory"
									background-color="white"
									multiple
									:rules="[rules.required]"
									dense
									outlined
									hide-details
								/>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
			</v-sheet>
			<v-card-actions class="pa-2">
				<v-row no-gutters>
					<v-col sm="3" cols="0"></v-col>
					<v-col sm="6" cols="12" class="text-center">
						<v-btn @click="addItem" color="secondary">
							<v-icon class="mr-1">mdi-plus</v-icon>
							追加する
						</v-btn>
					</v-col>
					<v-col sm="3" cols="12" class="mt-4 mt-sm-0 text-right">
						<ConstructionMaterialNewDialog
							:category="category"
							:categories="categories"
							@create-item="createItem($event)"
						/>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import ConstructionMaterialNewDialog from "./ConstructionMaterialNewDialog.vue"
import dialogMixin from "../../../helper/dialogMixin"

export default {
	mixins: [dialogMixin("withoutBtn")],
	props: {
		category: {
			type: String,
			required: false,
			default: null,
		},
		categories: {
			type: Array,
			required: false,
			default: () => [],
		},
	},
	components: {
		ShowDetailRecord,
		ConstructionMaterialNewDialog,
	},
	data() {
		return {
			newDialog: false,
			TODO: null,
			items: [], // TODO: propsかも
			common,
			rules,
		}
	},
	methods: {
		openNewDialog() {
			this.newDialog = true
		},
		addItem() {
			const item = {}
			this.$emit("add-item", this.selectedCategory, item)
		},
		createItem(item) {
			this.$emit("add-item", this.selectedCategory, item)
			this.closeDialog()
		},
	},
	computed: {
		categoryName() {
			return this.categories.find((category) => category.id === this.category)?.name
		},
		itemsByCategory() {
			return this.items.filter((item) => item.category === this.category)
		},
	},
}
</script>